module.exports = __webpack_public_path__ + "img/banlirou.899e93ca.jpg";